export default __webpack_public_path__ + "static/1-17a30a747d317ec6271d38e35422674c.png";